import i18n from '../i18n';
import { GetUniversities } from '../helper/apiHelper';
import type { ReducedUniversity } from '../Types/interfaces';

const checkUniversityNameExists = async (name: string): Promise<boolean> => {
  try {
    const universities = await GetUniversities();
    const exists = universities.some(
      (university: ReducedUniversity): boolean => university.name === name
    );
    return exists;
  } catch (error) {
    console.error(i18n.t('validator.universityNameUsed'), error);
    return false;
  }
};

export const validateUniversityName = async (
  _: unknown,
  value: string
): Promise<void> => {
  if (!value) {
    return Promise.resolve();
  }
  const exists = await checkUniversityNameExists(value);
  if (exists) {
    return Promise.reject(new Error(i18n.t('validator.universityNameUsed')));
  }
  return Promise.resolve();
};
